export default "__VITE_ASSET__D3IZxq$r__"